/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Dataroom_Retryall3Inputs */

const en_coinvestments_dataroom_retryall3 = /** @type {(inputs: Coinvestments_Dataroom_Retryall3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retry all`)
};

/**
* | output |
* | --- |
* | "Retry all" |
*
* @param {Coinvestments_Dataroom_Retryall3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_retryall3 = /** @type {((inputs?: Coinvestments_Dataroom_Retryall3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Retryall3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_retryall3(inputs)
});
export { coinvestments_dataroom_retryall3 as "coInvestments_dataRoom_retryAll" }